module.exports = __webpack_public_path__ + "img/4.cleaned_sink.d2ffa6f8.svg";